import { useFormik } from "formik";
import apiRequest from "../../../../utils/admin/apiRequest";
import Button from "../../../ui/utils/Button";
import Alert from "../../../ui/utils/Alert";
import { useEffect, useState } from "react";
import AsyncSearchSelect from "../../../ui/form/AsyncSearchSelect";
import usePost from "../../../../hooks/api/usePost";
import useFetch from "../../../../hooks/api/useFetch";
import SelectField from "../../../ui/form/SelectField";

const ExcelAssign = ({ data, closeModal, callback }) => {
  const [progress, setProgress] = useState(0);
  const [serverError, setServerError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const { error, isLoading, post, serverErrors } = usePost(apiRequest.assignToVendor);

  const formik = useFormik({
    initialValues: {
      corporateCodeId: "",
      vendorManagerId: "",
      excelId: data?._id || "",
    },
    onSubmit: async (values, { resetForm }) => {
      const payload = {
        corporateCodeId: values.corporateCodeId,
        vendorManagerId: values.vendorManagerId,
        excelId: data?._id,
      };
      const response = await post({ data: { body: payload } });
      if (response?.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });


  const { data: corporateCodes } = useFetch({
    apiMethod: apiRequest.getCorporateCodeIdCode,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
  });


  const {
    data: vendors,
    refetch: fetchVendors,
    setBlankResponse,
  } = useFetch({
    apiMethod: apiRequest.getVendorByCorporateCodeId,
    body: { paginate: false, sortField: "corporateName", sortOrder: "asc" },
    autoFetch: false,
  });


  useEffect(() => {
    const corporateCodeId = formik.values.corporateCodeId;

    if (corporateCodeId) {
      fetchVendors({ corporateCodeId });
    } else {
      setBlankResponse();
      formik.setFieldValue("vendorManagerId", "");
    }
  }, [formik.values.corporateCodeId]);





  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Assign Excel to Vendor Manager</h2>
      <div className="border-b" />

      <form onSubmit={formik.handleSubmit} className="text-sm">
        {serverError && <Alert message={serverError} type="error" />}
        {successMsg && <Alert message={successMsg} type="success" />}

        <div className="p-4 space-y-4">

          <SelectField
            name="corporateCodeId"
            label="Corporate Code"
            placeholder="Select Corporate Code"
            value={formik.values.corporateCodeId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.corporateCodeId}
            error={
              formik.touched.corporateCodeId &&
              formik.errors.corporateCodeId
            }

            options={(corporateCodes?.corporates || []).map((item) => ({
              value: item._id,
              label: item.corporateCode,
            }))}
          />




          <SelectField
            name="vendorManagerId"
            label="Vendor Manager"
            placeholder="Select Vendor Manager"
            value={formik.values.vendorManagerId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.vendorManagerId}
            error={
              formik.touched.vendorManagerId &&
              formik.errors.vendorManagerId
            }
            options={(vendors || []).map((item) => ({
              value: item._id,
              label: item.name,
            }))}
          />





          {progress > 0 && (
            <div className="w-full bg-gray-200 rounded-full h-3 mt-4">
              <div
                className="bg-blue-500 h-3 rounded-full text-center text-white text-xs"
                style={{ width: `${progress}%` }}
              >
                {progress}%
              </div>
            </div>
          )}
        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Assigning..."
            isLoading={loading}
            disabled={!formik.values.vendorManagerId}
          >
            Assign
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ExcelAssign;
